import { format, parseISO } from 'date-fns';

/**
 * Formats a number as Philippine Peso (PHP)
 */
export const formatPHP = (amount) => {
  return new Intl.NumberFormat('en-PH', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

/**
 * Formats a date string (YYYY-MM-DD) to "MMM d, yyyy - EEE"
 * Example: "2026-03-12" -> "Mar 12, 2026 - Thu"
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = parseISO(dateString);
    return format(date, 'MMM d, yyyy - EEE');
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};